import type { UserRole } from "../../../api/useUsers";
import t from "../../../i18n";

export type GlobalRoleOptionBase = {
  label: string;
  description: string;
  value: Exclude<UserRole, null>;
};

export function getGlobalRoleName(role: UserRole) {
  switch (role) {
    case "ADMIN":
      return t("users.selectFilter.application_admin");
    case "ALL_PROJECTS_READER":
      return t("users.table.row.menu.roles.application.read.title");
    case "ALL_PROJECTS_WRITER":
      return t("users.table.row.menu.roles.application.write.title");
    case "ALL_PROJECTS_SETUPER":
      return t("users.table.row.menu.roles.application.setup.title");
    case "PROD_READER":
      return t("users.selectFilter.project_prod_read_only");
    case "ALL_PROJECTS_READER_WITH_JUPYTER":
      return t("users.table.row.menu.roles.application.read_access_jupyterhub.title");
    case "SUPER_ADMIN":
      return "Super Admin";
    case "DIAGNOSER":
    case null:
      return t("users.selectFilter.none");
    default:
      throw new Error(role satisfies never);
  }
}

export const getGlobalRoleOptionsBase = (): GlobalRoleOptionBase[] => [
  {
    label: t("users.table.row.menu.roles.application.read_prod_only.title"),
    description: t("users.table.row.menu.roles.application.read_prod_only.description"),
    value: "PROD_READER",
  },
  {
    label: t("users.table.row.menu.roles.application.read.title"),
    description: t("users.table.row.menu.roles.application.read.description"),
    value: "ALL_PROJECTS_READER",
  },
  {
    label: t("users.table.row.menu.roles.application.read_access_jupyterhub.title"),
    description: t("users.table.row.menu.roles.application.read_access_jupyterhub.description"),
    value: "ALL_PROJECTS_READER_WITH_JUPYTER",
  },
  {
    label: t("users.table.row.menu.roles.application.write.title"),
    description: t("users.table.row.menu.roles.application.write.description"),
    value: "ALL_PROJECTS_WRITER",
  },
  {
    label: t("users.table.row.menu.roles.application.setup.title"),
    description: t("users.table.row.menu.roles.application.setup.description"),
    value: "ALL_PROJECTS_SETUPER",
  },
  {
    label: t("users.table.row.menu.roles.application.admin.title"),
    description: t("users.table.row.menu.roles.application.admin.description"),
    value: "ADMIN",
  },
];
